/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const OptimizeIconConfig = {
  name: 'OptimizeIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M256 758.857l-128 128h-64v-64l128-128zM320 950.857h64v-128h-64zM576 630.857h128v-64h-128zM640 822.857v64h-64l-128-128 64-64zM0 630.857h128v-64h-128zM320 374.857h64v-128h-64zM64 374.857v-64h64l128 128-64 64zM1010 68.857l-636.118 636.118c-18.668 18.668-49.214 18.668-67.882 0l-60.118-60.118c-18.668-18.668-18.668-49.214 0-67.882l636.118-636.118c18.668-18.668 49.214-18.668 67.882 0l60.118 60.118c18.668 18.668 18.668 49.214 0 67.882zM480 406.857l-192 192 64 64 192-192-64-64z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
};
export default createIcon(OptimizeIconConfig);
//# sourceMappingURL=optimize-icon.js.map